export function byMostRecent<T extends { created?: number }>(a: T, b: T): number {
    return (b?.created || 0) - (a?.created || 0);
}
